import Card from './Card.component';
export default Card;